/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { Button } from '@/components/button';
import { Col, Form, Row, Select, DatePicker } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useEffect, useMemo } from 'react';
import {
  getListAdminUser,
  watchListAdminUser
} from '@/redux/slices/admin.slice';
import { PAGINATION_PARAMS } from '@/constants/pagination.constant';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import {
  fetchModulesAdminLog,
  watchModulesAdminLog
} from '@/redux/slices/module.slice';

type AdminActivityLogSearcherProps = {
  onSearch: (values: FilterAdminActivityLog) => void;
};

const { RangePicker } = DatePicker;

export const AdminActivityLogSearcher = ({
  onSearch
}: AdminActivityLogSearcherProps) => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const listAdminUser = useAppSelector(watchListAdminUser);
  const modules = useAppSelector(watchModulesAdminLog);

  const functionOptions = useMemo(
    () => [
      { value: '', label: 'Tất cả' },
      ...modules.map((item) => ({ value: item.module, label: item.module }))
    ],
    [modules]
  );

  const adminOptions = useMemo(
    () => [
      { value: '', label: 'Tất cả' },
      ...listAdminUser.map((admin) => ({
        value: admin.id,
        label: admin.fullName
      }))
    ],
    [listAdminUser]
  );

  const handleSearch = () => {
    const values = form.getFieldsValue();
    onSearch(values);
  };

  const handleReset = () => {
    form.resetFields();
  };

  useEffect(() => {
    dispatch(getListAdminUser({ offset: 1, limit: PAGINATION_PARAMS.unLimit }));
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchModulesAdminLog());
  }, [dispatch]);

  return (
    <Form
      form={form}
      name='user-client-searcher'
      layout='horizontal'
      labelCol={{ span: 4 }}
      wrapperCol={{ span: 20 }}
    >
      <Row gutter={[20, 0]} align='middle'>
        <Col span={6}>
          <Form.Item
            label='Chọn khoảng thời gian'
            name='timeRange'
            initialValue=''
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <RangePicker format='DD/MM/YYYY' style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label='Người quản trị'
            name='userId'
            initialValue=''
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Select
              style={{ width: '100%' }}
              allowClear
              showSearch
              placeholder='Chọn người quản trị'
              optionFilterProp='label'
              options={adminOptions}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label='Chức năng'
            name='function'
            initialValue=''
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Select
              style={{ width: '100%' }}
              allowClear
              showSearch
              placeholder='Chọn chức năng'
              optionFilterProp='label'
              options={functionOptions}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Row gutter={[16, 0]}>
            <Col>
              <Button
                onClick={handleReset}
                type='default'
                css={searchBtnStyles}
              >
                Xoá bộ lọc
              </Button>
            </Col>
            <Col>
              <Button
                type='primary'
                css={searchBtnStyles}
                icon={<SearchOutlined />}
                iconPosition='start'
                onClick={handleSearch}
              >
                Tìm kiếm
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};

const searchBtnStyles = css`
  margin-top: 1.6rem;
`;
